export interface SearchState<T> {
  data: T[]; // Instead of 'projects', use generic data array
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  } | null;
  filters: SearchFilters; // We'll define this separately
  sorting: {
    sortBy: string;
    sortOrder: number;
  };
}

// Base filter interface that all search types will share
export interface BaseSearchFilters {
  status?: string;
  dateFrom?: string;
  dateTo?: string;
  location?: string;
  priceRange?: {
    min: number;
    max: number;
  };
}

export interface ProjectSearchFilters extends BaseSearchFilters {
  companyName?: string;
  growthStage?: string;
  productStage?: string;
}

export interface ICPSearchFilters extends BaseSearchFilters {}

export interface AdStrategySearchFilters extends BaseSearchFilters {}

// Union type of all possible filter types
export type SearchFilters =
  | ProjectSearchFilters
  | ICPSearchFilters
  | AdStrategySearchFilters;

export const SORT_OPTIONS = {
  CREATED_DESC: { value: "createdAt-1", label: "Newest First" },
  CREATED_ASC: { value: "createdAt-2", label: "Oldest First" },
};
